import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import cn from 'classnames';

import { RadioButton } from '@infologistics/frontend-libraries';

import { useAppSelector } from '@hooks';
import { ISignatureValue } from '../types';

import styles from '../SignatureModal.module.scss';

const SignatureChoose: FC<FormikProps<ISignatureValue>> = ({
  values,
  setFieldValue,
}) => {
  const { t } = useTranslation(['envelope']);
  const { newSignature } = values;
  const signatureImg = useAppSelector(
    (state) =>
      state.shared.envelope.accessAuthorizedTo.user?.electronicSignatureImage,
  );

  const renderSignature = (
    signature: string,
    radioButtonName: string,
  ): ReactNode => {
    const handleClick = () => {
      setFieldValue('newSignature', signature);
    };

    return (
      <li className={cn(styles.signature_choose_item, 'px-4 py-2 d-flex')}>
        <RadioButton
          name={radioButtonName}
          value={signature}
          checked={newSignature === signature}
          onChange={handleClick}
          className='mr-4'
        />
        <img
          height={54}
          src={`data:image/png;base64, ${signature}`}
          alt={t('profile:signature:signatureImage')}
          onClick={handleClick}
          className='pointer'
        />
      </li>
    );
  };

  return (
    <ul className='list-unstyled full-width mt-4'>
      {signatureImg && renderSignature(signatureImg, 'signatureImg')}
    </ul>
  );
};

export default SignatureChoose;
